<template>
  <div class="panel-wraper"
       :style="{'background':`url(${bgUrl}) no-repeat ${getPosition}`}">
    <div class="panel-img">
      <img :src="url"
           alt="图像加载失败">
    </div>
    <div class="panel-content">
      <p v-for="text in content"
         :key="text.id">{{text}}</p>
    </div>
    <p class="panel-text">您暂时无该功能权限 联系我们商务 为您设计专业的{{section}}</p>
  </div>
</template>

<script>
export default {
  props: {
    content: [Array, String],
    url: String,
    bgUrl: String,
    bgAlign: String,// left-top  left-bottom  right-top right-bottom
    section: String,
  },
  computed: {
    getPosition () {
      const position = {
        'left-top': '0% 0%',
        'left-bottom': '0% 100%',
        'right-top': '100% 0%',
        'right-bottom': '100% 100%',
      }
      return this.bgAlign in position ? position[this.bgAlign] : '0%'
    }
  }
}
</script>

<style lang="scss" scoped>
$line_height: 30px;
.panel-wraper {
  text-align: center;
  padding: 20px 0;

  .panel-content {
    font-size: 16px;
    font-weight: 500;
    color: #666666;
    margin: 10px 0 10px;
    line-height: $line_height;
  }
  .panel-text {
    font-size: 12px;
    color: #999999;
    line-height: $line_height;
  }
}
</style>